import { IonIcon } from '@ionic/react';
import { football } from 'ionicons/icons';

export const PenaltyGoalIcon: React.FC = () => (
  <IonIcon icon={football} style={{ color: 'green' }} />
);
